<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="终端名称"
                  >
                    <el-input
                      v-model="dialogViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="联系人"
                  >
                    <el-input
                      v-model="dialogViewForm.linkman"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="联系电话"
                  >
                    <el-input
                      v-model="dialogViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案编号"
                  >
                    <el-input
                      v-model="dialogViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案名称"
                  >
                    <el-input
                      v-model="dialogViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="物料发放人"
                  >
                    <el-input
                      v-model="dialogViewForm.materialsOperater"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放时间"
                  >
                    <el-input
                      v-model="dialogViewForm.issueDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放物料名称"
                  >
                    <el-input
                      v-model="dialogViewForm.materialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="单位"
                  >
                    <el-input
                      v-model="dialogViewForm.unitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放数量"
                  >
                    <el-input
                      v-model="dialogViewForm.amount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访人"
                  >
                    <el-input
                      v-model="dialogViewForm.callBackUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访时间"
                  >
                    <el-date-picker
                      v-model="dialogViewForm.callBackDateStr"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访方式"
                  >
                    <el-input
                      v-model="dialogViewForm.callBackMethodStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访结果"
                  >
                    <el-input
                      v-model="dialogViewForm.callBackResultStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="处理意见"
                  >
                    <el-input
                      v-model="dialogViewForm.dealOpinion"
                      rows="3"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              其它信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="回访人"
                  >
                    <el-input
                      v-model="dialogViewForm.operatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访时间"
                  >
                    <el-input
                      v-model="dialogViewForm.operationTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="复核人"
                  >
                    <el-input
                      v-model="dialogViewForm.checkName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="复核时间"
                  >
                    <el-input
                      v-model="dialogViewForm.checkTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="复核意见">
                    <el-input
                      v-model="dialogViewForm.checkOpinion"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { initCallBackBillApi } from '@/api/callBackBill'
export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogViewForm: {
      }
    }
  },
  watch: {
      dialogVisible (val) {
        if (val) {
          this.loading = true
          this.dialogViewForm = {
              provinceName: '',
              cityName: '',
              storeName: '',
              linkman: '',
              phone: '',
              schemeName: '',
              schemeNo: '',
              materialsOperater: '',
              issueDate: '',
              materialsName: '',
              unitName: '',
              amount: '',
              callBackUserName: '',
              callBackDateStr: '',
              callBackMethodStr: '',
              callBackResultStr: '',
              dealOpinion: '',
              remark: '',
              operatorName: '',
              operationTimeStr: '',
              checkName: '',
              checkTimeStr: '',
              checkOpinion: ''
            }
          this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData () {
      initCallBackBillApi({id: this.dataId}).then(res => {
        const { data } = res
        for(let key in this.dialogViewForm){
          this.dialogViewForm[key] = data[key]
        }
        this.loading = false
      })
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
